import { Head, router } from '@inertiajs/react'
import type { AccountSummary } from '@/types'
import ImpersonationBanner from '@/components/ImpersonationBanner'

interface AccountsProps {
  accounts: AccountSummary[]
  preferred_account_id: string | null
}

export default function Accounts({ accounts }: AccountsProps) {
  function handleLogout() {
    router.delete('/logout')
  }

  return (
    <div className="min-h-screen bg-base-200 flex flex-col">
      <Head title="Choose an account" />
      <ImpersonationBanner />
      <div className="flex flex-1 flex-col items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <img src="/logo.svg" alt="ImpactCheck" className="h-8 mx-auto mb-4" />
          {accounts.length > 0 ? (
            <>
              <h1 className="text-xl font-bold">Choose an account</h1>
              <p className="text-sm text-base-content/60 mt-1">
                You belong to more than one organization.
              </p>
            </>
          ) : (
            <>
              <h1 className="text-xl font-bold">No organizations yet</h1>
              <p className="text-sm text-base-content/60 mt-1">
                You're not a member of any organization. Ask an admin to invite you, or contact support.
              </p>
            </>
          )}
        </div>

        {accounts.length > 0 && (
          <div className="card bg-base-100 shadow-sm overflow-hidden">
            <ul className="divide-y divide-base-200">
              {accounts.map((account) => (
                <li key={account.slug}>
                  <a
                    href={account.url ?? `/${account.slug}/surveys`}
                    className="flex items-center gap-3 p-4 hover:bg-base-200 transition-colors"
                  >
                    <div className="flex items-center justify-center size-10 rounded-lg bg-base-200 shrink-0 overflow-hidden">
                      {account.logo_url ? (
                        <img src={account.logo_url} alt="" className="size-full object-contain" />
                      ) : (
                        <span className="iconify lucide--building-2 size-5 text-base-content/50" />
                      )}
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="font-medium truncate">{account.name}</p>
                      <p className="text-xs text-base-content/50 capitalize">{account.role}</p>
                    </div>
                    <span className="iconify lucide--chevron-right size-5 text-base-content/30" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="text-center mt-6">
          <button onClick={handleLogout} className="btn btn-ghost btn-sm">
            <span className="iconify lucide--log-out size-4" />
            Log out
          </button>
        </div>
      </div>
      </div>
    </div>
  )
}
